import { api } from './api';

/** Keep the game mounted throughout provider navigation so private drafts survive. */
export function signInWithProvider(provider: 'google', signal: AbortSignal, beforeStart?:()=>Promise<void>): Promise<void> {
  const popup = window.open('about:blank', 'graffiti-sign-in', 'popup,width=480,height=680');
  if (!popup) return Promise.reject(new Error('Your browser blocked the sign-in window. Allow pop-ups for this site and try again.'));
  popup.document.title = 'Signing in · Graffiti';
  popup.document.body.textContent = 'Opening secure sign-in…';
  return new Promise((resolve, reject) => {
    let finished = false;
    let flow: string | undefined;
    let confirming = false;
    const finish = (error?: Error) => {
      if (finished) return;
      finished = true;
      window.clearInterval(poll); window.clearTimeout(timeout);
      window.removeEventListener('message', receive); signal.removeEventListener('abort', abort);
      popup.close();
      if (error && flow) void api.cancelOAuth(flow).catch(() => {});
      if (error) reject(error); else resolve();
    };
    const confirm = async (reportedSuccess = false) => {
      if (finished || confirming || !flow) return;
      confirming = true;
      try { const session = await api.session(true); if (session.kind === 'member') finish(); else if (reportedSuccess) finish(new Error('Sign-in could not be confirmed. Please try again.')); }
      catch { if (reportedSuccess) finish(new Error('Sign-in could not be confirmed. Please try again.')); }
      finally { confirming = false; }
    };
    const receive = (event: MessageEvent) => {
      if (event.origin !== location.origin || event.source !== popup || event.data?.type !== 'graffiti-oauth-result') return;
      if (event.data.ok === true) void confirm(true);
      else finish(new Error(typeof event.data.message === 'string' ? event.data.message : 'Sign-in could not finish. Please try again.'));
    };
    const abort = () => finish(new Error('Sign-in was cancelled.'));
    // Providers can sever window.opener using COOP, making a live window appear
    // closed. Check the authoritative session; leave cancellation to the user.
    const poll = window.setInterval(() => { if (popup.closed) void confirm(); }, 1500);
    const timeout = window.setTimeout(() => finish(new Error('Sign-in timed out. Please try again.')), 10 * 60_000);
    window.addEventListener('message', receive); signal.addEventListener('abort', abort, { once: true });
    if (signal.aborted) { abort(); return; }
    const start=()=>{if(finished)return Promise.resolve();return api.startOAuth(provider).then(({url, flow: startedFlow}) => {
      flow = startedFlow;
      if (finished) { void api.cancelOAuth(startedFlow).catch(() => {}); return; }
      const target = new URL(url);
      if (!['http:', 'https:'].includes(target.protocol)) throw new Error('Sign-in is unavailable. Please try again.');
      popup.location.replace(target.href);
    });};
    // Keep popup creation in the user gesture, but preserve pending guest work
    // before starting any flow which can replace the browser's identity.
    void (beforeStart?Promise.resolve().then(beforeStart).then(start):start()).catch(error => finish(error instanceof Error ? error : new Error('Sign-in could not start. Please try again.')));
  });
}
